import React, {useEffect} from "react";
import "./App.css";
import Home from "./client/Pages/Home/Home";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Register from "./client/Pages/Register/Register";
import Login from "./client/Pages/Login/Login";
import ServiceRegister from './client/Pages/ServiceRegister/ServiceRegister'
import {useSelector, useDispatch} from 'react-redux'
import Cookies from 'js-cookie';
import {currentUser} from './client/Features/authSlice'
import WebsiteLayout from "./client/Layouts/WebsiteLayout";
import Layout from './admin/components/layout/Layout'
import Dashboard from "./admin/pages/Dashboard";
import RegisterStore from "./client/Pages/RegisterStore/RegisterStore";
import AddProducts from "./admin/pages/Products";
import AddLocalSellerProducts from "./admin/pages/AddLocalSellerProducts";
import AddTechProducts from "./admin/pages/AddTechProducts";
import AddHealthProduct from "./admin/pages/AddHealthProduct";
import Settings from "./admin/pages/Settings";
import Profile from "./admin/pages/Profile";
import Stores from "./admin/pages/Stores";
import EditStore from "./admin/pages/EditStore";
import GetStoreProducts from "./admin/pages/GetStoreProducts";
import EditeStoreProducts from "./admin/pages/EditStoreProducts";
import GetSmartTechProducts from "./admin/pages/GetSmartTechProducts";
import EditTechStoreProducts from "./admin/pages/EditTechStoreProducts";
import GetLocalSellerProducts from "./admin/pages/GetLocalSellerProducts";
import EditLocalSellerProducts from "./admin/pages/EditLocalSellerProducts";
import GetHealthProducts from "./admin/pages/GetHealthProducts";
import EditHealthProduct from "./admin/pages/EditHealthProduct";
import ServiceProviderRegister from "./client/Pages/RegisterServices/RegisterServices";
import Marketplace from "./client/Pages/Marketplace/Marketplace";
import SingleProduct from "./client/Pages/SingleProduct/SingleProduct";
import SetPassword from "./client/Pages/Set-Password/SetPassword";
import Location from "./client/Pages/Location";
import ProductLocation from "./client/Pages/ProductLocation/ProductLocation";
import GetServiceProvider from "./admin/pages/GetServiceProvider";

function App() {
  const token = Cookies.get('accessToken');
  const dispatch = useDispatch()
  const refreshToken = localStorage.getItem('refreshToken')
  useEffect(() => {
    if (token) {
      dispatch(currentUser(refreshToken));
    }
  }, [dispatch, refreshToken, token]);

  const { user } = useSelector((state) => state.auth);
  return (
      <BrowserRouter>
        <Routes>
          { user ? (
            <Route path="*" element={
              <Routes>
                <Route path="/" element={<WebsiteLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="sell-on-findNow" element={<ServiceRegister />} />
                  <Route path="register-store" element={<RegisterStore />} />
                  <Route path="service-provider-register" element={<ServiceProviderRegister />} />
                  <Route path="marketplace" element={<Marketplace />} />
                  <Route path="product/:id" element={<SingleProduct />} />
                  <Route path="register" element={<Register />} />
                  <Route exact path='login' element={<Login />} />
                </Route>
                  <Route path="map" element={<Location />} />
                <Route path="/admin/" element={<Layout />}>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="add-store-products" element={<AddProducts />} />
                  <Route path="store-products" element={<GetStoreProducts />} />
                  <Route path="edit-store-products/:id" element={<EditeStoreProducts />} />
                  <Route path="add-local-seller-products" element={<AddLocalSellerProducts />} />
                  <Route path="local-seller-products" element={<GetLocalSellerProducts />} />
                  <Route path="edit-local-seller-products/:id" element={<EditLocalSellerProducts />} />
                  <Route path="add-tech-products" element={<AddTechProducts />} />
                  <Route path="tech-products" element={<GetSmartTechProducts />} />
                  <Route path="edit-tech-products/:id" element={<EditTechStoreProducts />} />
                  <Route path="add-health-products" element={<AddHealthProduct />} />
                  <Route path="health-products" element={<GetHealthProducts />} />
                  <Route path="edit-health-products/:id" element={<EditHealthProduct />} />
                  <Route path="get-service-provider" element={<GetServiceProvider />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="stores" element={<Stores />} />
                  <Route path="edit-store" element={<EditStore />} />
                </Route>
              </Routes>
            } />
          ):(
            <Route path="*" element={
              <Routes>
                <Route path="/" element={<WebsiteLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="marketplace" element={<Marketplace />} />
                  <Route path="product/:id" element={<SingleProduct />} />
                  <Route path="/register" element={<Register />} />
                  <Route path='/set-password/:token' element={<SetPassword />} />
                  <Route exact path='/login' element={<Login />} />
                  <Route exact path='*' element={token ? refreshToken ? <Outlet /> : <Navigate to='/login' /> : <Navigate to='/login' />} />
                </Route>
                  <Route path="map" element={<Location />} />
              </Routes>
            } />
          )
          }
        </Routes>
      </BrowserRouter>
  );
}

export default App;
